import enums from '@/enums';

export default function goMqPlugin(Vue) {
  Vue.mixin({
    computed: {
      gpMqIsMobile() {
        return this.$mq === enums.mqBreakpoints.MOBILE;
      },
      gpMqIsTablet() {
        return this.$mq === enums.mqBreakpoints.TABLET;
      },
      gpMqIsMobileOrTablet() {
        return this.gpMqIsMobile || this.gpMqIsTablet;
      },
      gpMqIsLaptop() {
        return this.$mq.includes(this.$enums.mqBreakpoints.LAPTOP);
      },
      gpMqIsDesktop() {
        return this.$mq.includes(this.$enums.mqBreakpoints.DESKTOP);
      },
      gpMqIsLessOrEqualLaptopSmall() {
        return this.$mq === enums.mqBreakpoints.MOBILE
        || this.$mq === enums.mqBreakpoints.TABLET
        || this.$mq === enums.mqBreakpoints.LAPTOP_S;
      },
      gpMqIsLessOrEqualLaptopMedium() {
        return this.$mq === enums.mqBreakpoints.MOBILE
        || this.$mq === enums.mqBreakpoints.TABLET
        || this.$mq === enums.mqBreakpoints.LAPTOP_S
        || this.$mq === enums.mqBreakpoints.LAPTOP_M;
      },
    },
  });
}
